import { Base_Url } from "../../BaseURL/BaseUrl";
import {
  getApiWithAuthorization,
  postApiWithAuthorization,
} from "../auth/ApiMethod";

const normalizeNotification = (item = {}, index = 0) => ({
  id: item.notificationKeyID || item.notificationKeyId || item.id || index + 1,
  notificationKeyID:
    item.notificationKeyID || item.notificationKeyId || item.id || null,
  title: item.title || "",
  message: item.message || "",
  referenceType: item.referenceType || "",
  referenceID: item.referenceID || item.referenceId || null,
  notificationStatus: item.notificationStatus || null,
  isSeen:
    item.isSeen === true ||
    item.isSeen === "true" ||
    item.notificationStatus === "Seen",
  createdOnDate: item.createdOnDate || item.createdDate || "",
});

const normalizeListResponse = (response) => ({
  ...response,
  responseData: {
    ...response?.responseData,
    data: Array.isArray(response?.responseData?.data)
      ? response.responseData.data.map(normalizeNotification)
      : [],
  },
});

export const GetNotificationCount = async (userKeyID) =>
  getApiWithAuthorization(
    `${Base_Url}api/Notification/GetNotificationCount?UserKeyID=${encodeURIComponent(
      userKeyID || "",
    )}`,
  );

export const GetNotificationList = async (params = {}) => {
  const response = await postApiWithAuthorization(
    `${Base_Url}api/Notification/GetNotificationList`,
    {
      pageNo: params.pageNo ?? 0,
      pageSize: params.pageSize ?? 30,
      userKeyID: params.userKeyID || null,
    },
  );

  if (response?.statusCode === 200) {
    return normalizeListResponse(response);
  }

  return response;
};

export const UpdateNotificationStatus = async (params = {}) =>
  postApiWithAuthorization(
    `${Base_Url}api/Notification/UpdateNotificationStatus`,
    {
      userKeyID: params.userKeyID || null,
      notificationKeyID: params.notificationKeyID || null,
      notificationStatus: params.notificationStatus,
    },
  );
